import { useCallback, useRef } from 'react';
import type { FocusEvent, CSSProperties, ReactNode } from 'react';
import { useOnClickOutside } from 'usehooks-ts';

interface ClickAwayListenerProps {
  children: ReactNode | ReactNode[];
  className?: string;
  isActive: boolean;
  style?: CSSProperties;
  onClickAway: () => void;
}

const ClickAwayListener = ({
  children,
  className,
  isActive,
  onClickAway,
  style,
}: ClickAwayListenerProps) => {
  const targetRef = useRef<HTMLDivElement | null>(null);

  const handleOnClickAway = useCallback(() => {
    if (isActive) {
      onClickAway();
    }
  }, [isActive, onClickAway]);

  useOnClickOutside(targetRef, handleOnClickAway);

  const handleOnBlur = (e: FocusEvent<HTMLDivElement>) => {
    if (isActive && targetRef.current && !targetRef.current.contains(e.relatedTarget as Node)) {
      onClickAway();
    }
  };

  return (
    <div className={className} onBlur={handleOnBlur} ref={targetRef} style={style} tabIndex={-1}>
      {children}
    </div>
  );
};

export default ClickAwayListener;
